import { render, staticRenderFns } from "./addNewSalaryComponent.vue?vue&type=template&id=b3ff380a&scoped=true"
import script from "./addNewSalaryComponent.vue?vue&type=script&lang=js"
export * from "./addNewSalaryComponent.vue?vue&type=script&lang=js"
import style0 from "./addNewSalaryComponent.vue?vue&type=style&index=0&id=b3ff380a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ff380a",
  null
  
)

export default component.exports